import React, { createContext, useContext, useState, ReactNode } from 'react';
import { DesignSettings } from '../types/DesignSettings';
import { DEFAULT_DESIGN_SETTINGS } from '../constants/defaultDesignSettings';

interface DesignContextType {
  designSettings: DesignSettings;
  updateDesignSettings: (newSettings: Partial<DesignSettings>) => void;
  resetDesignSettings: () => void;
}

const DesignContext = createContext<DesignContextType | undefined>(undefined);

interface DesignProviderProps {
  children: ReactNode;
}

export const DesignProvider: React.FC<DesignProviderProps> = ({ children }) => {
  const [designSettings, setDesignSettings] = useState<DesignSettings>(DEFAULT_DESIGN_SETTINGS);

  const updateDesignSettings = (newSettings: Partial<DesignSettings>) => {
    setDesignSettings(prevSettings => ({
      ...prevSettings,
      ...newSettings
    }));
  };

  const resetDesignSettings = () => {
    setDesignSettings(DEFAULT_DESIGN_SETTINGS);
  };

  const value: DesignContextType = {
    designSettings,
    updateDesignSettings,
    resetDesignSettings
  };

  return (
    <DesignContext.Provider value={value}>
      {children}
    </DesignContext.Provider>
  );
};

export const useDesignContext = (): DesignContextType => {
  const context = useContext(DesignContext);
  if (context === undefined) {
    throw new Error('useDesignContext must be used within a DesignProvider');
  }
  return context;
}; 